// Device status freshness logic
// Calculates device connectivity state from online flag + last_status_update timestamp

// Threshold: 10 minutes — Tuya heartbeat interval is ~5-15 min
export const STATUS_STALE_THRESHOLD_MS = 10 * 60 * 1000;

/**
 * Returns one of: "fresh_online" | "stale_online" | "offline" | "unknown"
 */
export function getDeviceFreshness(device) {
  const { online, last_status_update } = device;

  // No data at all → Unknown
  if (!last_status_update) return "unknown";

  // Explicitly offline → Offline
  if (!online) return "offline";

  // Online — check freshness
  const age = Date.now() - new Date(last_status_update).getTime();
  if (isNaN(age)) return "unknown";

  return age <= STATUS_STALE_THRESHOLD_MS ? "fresh_online" : "stale_online";
}

/**
 * Returns display config for a freshness state
 */
export function getFreshnessDisplay(freshness) {
  switch (freshness) {
    case "fresh_online":
      return {
        label: "Online",
        badgeClass: "bg-emerald-100 text-emerald-700",
        iconClass: "text-emerald-600",
        dotClass: "bg-emerald-500",
      };
    case "stale_online":
      return {
        label: "Belirsiz",
        badgeClass: "bg-amber-100 text-amber-700",
        iconClass: "text-amber-500",
        dotClass: "bg-amber-400",
      };
    case "offline":
      return {
        label: "Offline",
        badgeClass: "bg-slate-100 text-slate-500",
        iconClass: "text-slate-400",
        dotClass: "bg-slate-400",
      };
    default: // unknown
      return {
        label: "Bilinmiyor",
        badgeClass: "bg-blue-50 text-blue-500",
        iconClass: "text-blue-400",
        dotClass: "bg-blue-300",
      };
  }
}

/**
 * Returns human-readable time-ago string in Turkish
 */
export function timeAgoTr(isoString) {
  if (!isoString) return "Veri yok";
  const diff = Date.now() - new Date(isoString).getTime();
  if (isNaN(diff) || diff < 0) return "Veri yok";
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "Az once";
  if (mins < 60) return `${mins} dk once`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} saat once`;
  const days = Math.floor(hours / 24);
  return `${days} gun once`;
}
